import Vue from 'vue';
import Vuex from 'vuex';
import router, { slides } from '@/router/index';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lastSlide: '/',
    isBackMove: false,
    orientation: 'landscape',
    progress: 0,
    progressCount: slides.length - 2,
    reviews: [],
    isReviewSended: false,
  },
  getters: {
    isPortrait({ orientation }) {
      return orientation === 'portrait';
    },
  },
  mutations: {
    setOrientation(state, orientation) {
      state.orientation = orientation;
    },
    setLastSlide(state, slide) {
      state.lastSlide = slide;
    },
    setMoveFlag(state, flag) {
      state.isBackMove = flag;
    },
    setProgress(state, index) {
      const { progressCount } = state;
      state.progress = index >= progressCount - 1 ? 100 : Math.round(100 / progressCount) * (index + 1);
    },
    setReviews(state, reviews) {
      state.reviews = reviews;
    },
    setReviewStatus(state, status) {
      state.isReviewSended = status;
    },
  },
  actions: {
    sendFeedback(ctx, data) {
      return this.$axios.post('/feedback', data);
    },
    sendEvaluation(ctx, data) {
      return this.$axios.post('/lead', data);
    },
    sendReview(ctx, data) {
      return this.$axios.post('/comment', data);
    },
    fetchReviews({ commit }) {
      return this.$axios.get('/comment')
        .then(({ data }) => {
          commit('setReviews', data);
        });
    },
  },
});

router.beforeEach((to, from, next) => {
  const fromIndex = slides.findIndex((slide) => slide.path === from.path);
  const toIndex = slides.findIndex((slide) => slide.path === to.path);
  store.commit('setMoveFlag', fromIndex > toIndex);
  store.commit('setLastSlide', to.path);
  store.commit('setProgress', toIndex);
  next();
});

export default store;
